
import LayoutContent from '../../../components/layouts/content2';
import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import PlayGame from './playgame';
import SpecialsScreen from '../specials';

function Index({dishs, setShowListProduct, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [showPlaygame, setShowPlay] = useState(false);

     const [showSpecials, setShowSpecials] = useState(false);
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowListProduct} goHome={setShowHappy}>
                <div  style={{padding: '0 20px', background: "#DFDFDF", borderRadius: 30}}>
                    <div class="webview-container">
                       <iframe class="embed-responsive-item " id="iframeView" allowfullscreen="" src="https://preview.codecanyon.net/item/hang-glider-html5-game-construct-3/full_screen_preview/54261125?_ga=2.166757438.1841215333.1730929684-750675731.1728392142" style={{width: '100%', height: 800, border: 'none'}}></iframe>
                    </div>
                </div>
                  {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
        </LayoutContent>
        
        </div>
    );
}
export default Index;